export default "__VITE_ASSET__BjNDkBl3__"